module.exports = __webpack_public_path__ + "static/media/lifestyle2-small.366b5303.jpg";